<template>
  <div id="register_full_form">
    <div id="register_header">
      <HeaderLogin />
    </div>
    <div id="register_content">
      <div id="register_form">
        <div v-show="!viewCode">
          <div id="register_title">
            {{ messages.registerH[store.langSelect.value] }}
          </div>
          <div id="register_text">
            {{ messages.registerT[store.langSelect.value] }}
          </div>
          <div>
            <input
              :placeholder="messages.loginP[store.langSelect.value]"
              v-model="login"
              :class="[
                !loginClass
                  ? 'register_form_input'
                  : 'register_form_input_error',
              ]"
            />
            <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">
              <span v-if="errLogin != ''" id="errLogin" v-text="errLogin">
              </span>
            </div>
          </div>
          <div>
            <input
              :placeholder="messages.emailP[store.langSelect.value]"
              v-model="email"
              :class="[
                !emailClass
                  ? 'register_form_input'
                  : 'register_form_input_error',
              ]"
            />
          </div>
          <div>
            <input
              :placeholder="messages.passwordP[store.langSelect.value]"
              v-model="pass"
              :class="[
                !passClass
                  ? 'register_form_input'
                  : 'register_form_input_error',
              ]"
            />
          </div>
          <div>
            <input
              :placeholder="messages.passwordC[store.langSelect.value]"
              v-model="passConfirm"
              :class="[
                !passConfirmClass
                  ? 'register_form_input'
                  : 'register_form_input_error',
              ]"
            />
          </div>
        </div>
        <div v-show="viewCode" style="height: 382px">
          <div id="register_title">
            {{ messages.codeH[store.langSelect.value] }}
          </div>
          <div id="register_text">
            {{ messages.codeT[store.langSelect.value] }}
          </div>
          <div style="margin-top: 100px">
            <input
              :placeholder="messages.codeP[store.langSelect.value]"
              v-model="code"
              :class="[
                !codeClass
                  ? 'register_form_input'
                  : 'register_form_input_error',
              ]"
            />
            <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">
              <span v-if="errCode != ''" id="errCode" v-text="errCode"> </span>
            </div>
          </div>
        </div>
        <Button
          style="width: 180px; margin-bottom: 30px"
          @click="Registration"
          :text="messages.enterP[store.langSelect.value]"
        />
        <div id="register_login">
          <router-link to="/login">{{
            messages.footerL[store.langSelect.value]
          }}</router-link>
        </div>
      </div>
      <div
        id="register_img"
        :style="{
          background:
            'url(' +
            store.serverConf[store.currentServer].path +
            '/images/register.png)',
        }"
      >
        <svg
          style="position: absolute; top: 30px; right: 30px"
          width="107"
          height="107"
          viewBox="0 0 107 107"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g style="mix-blend-mode: hard-light">
            <circle cx="1.5" cy="1.5" r="1.5" fill="#E9E9E9" />
            <circle cx="1.5" cy="27.5" r="1.5" fill="#E9E9E9" />
            <circle cx="1.5" cy="53.5" r="1.5" fill="#E9E9E9" />
            <circle cx="1.5" cy="79.5" r="1.5" fill="#E9E9E9" />
            <circle cx="1.5" cy="105.5" r="1.5" fill="#E9E9E9" />
            <circle cx="27.5" cy="1.5" r="1.5" fill="#E9E9E9" />
            <circle cx="27.5" cy="27.5" r="1.5" fill="#E9E9E9" />
            <circle cx="27.5" cy="53.5" r="1.5" fill="#E82862" />
            <circle cx="27.5" cy="79.5" r="1.5" fill="#E9E9E9" />
            <circle cx="27.5" cy="105.5" r="1.5" fill="#E9E9E9" />
            <circle cx="53.5" cy="1.5" r="1.5" fill="#E9E9E9" />
            <circle cx="53.5" cy="27.5" r="1.5" fill="#E82862" />
            <circle cx="53.5" cy="53.5" r="1.5" fill="#E9E9E9" />
            <circle cx="53.5" cy="79.5" r="1.5" fill="#E82862" />
            <circle cx="53.5" cy="105.5" r="1.5" fill="#E9E9E9" />
            <circle cx="79.5" cy="1.5" r="1.5" fill="#E9E9E9" />
            <circle cx="79.5" cy="27.5" r="1.5" fill="#E9E9E9" />
            <circle cx="79.5" cy="53.5" r="1.5" fill="#E82862" />
            <circle cx="79.5" cy="79.5" r="1.5" fill="#E9E9E9" />
            <circle cx="79.5" cy="105.5" r="1.5" fill="#E9E9E9" />
            <circle cx="105.5" cy="1.5" r="1.5" fill="#E9E9E9" />
            <circle cx="105.5" cy="27.5" r="1.5" fill="#E9E9E9" />
            <circle cx="105.5" cy="53.5" r="1.5" fill="#E9E9E9" />
            <circle cx="105.5" cy="79.5" r="1.5" fill="#E9E9E9" />
            <circle cx="105.5" cy="105.5" r="1.5" fill="#E9E9E9" />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import HeaderLogin from "@/components/HeaderLogin";
import Button from "@/components/Button";
import { useMyStorage } from "@/store/global";
import md5 from "js-md5";

export default {
  components: {
    HeaderLogin,
    Button,
  },
  name: "RegisterPage",
  setup() {
    const store = useMyStorage();
    const messages = {
      passwordP: [
        "Пароль (минимум 6 знаков)",
        "Password (at least 6 characters)",
      ],
      loginP: [
        "Имя пользователя (минимум 3 знака)",
        "Username (at least 3 characters)",
      ],
      emailP: ["Ваш e-mail", "Email"],
      registerH: ["Новый аккаунт", "NEW ACCOUNT"],
      registerT: [
        "Присоединяйтесь к сообществу опционных трейдеров. Личный кабинет - первый шаг к новым технологиям торговли АЕ.",
        "Welcome to the options trading community. Registration is the fist step towards new AE trading technologies",
      ],
      passwordC: ["Ещё раз пароль", "Confirm password"],
      enterP: ["Создать", "Submit"],
      footerL: [
        "Уже есть аккаунт? Авторизуйтесь",
        "Already have an account? Sign in",
      ],
      codeH: ["Внимание", "ATTENTION"],
      codeT: [
        "На ваш email отправлен код подтверждения. Введите его пожалуйста.\n" +
          '(Если письмо долго не приходит то, проверьте пожалуйста папку "Спам", особенно если у вас mail.ru)',
        "A verification email has been sent to your email. Please enter the code to complete registration.",
      ],
      codeP: ["Код подтверждения", "Code"],
      testLogin: ["Не допустимый символ", "Not a valid character"],
    };
    return {
      store,
      messages,
    };
  },
  data() {
    return {
      login: "",
      loginClass: false,
      pass: "",
      passClass: false,
      passConfirm: "",
      passConfirmClass: false,
      firstName: "",
      lastName: "",
      email: "",
      emailClass: false,
      errLogin: "",
      errLoginHist: "",
      checkingEmail: "",
      viewCode: false,
      code: "",
      codeClass: false,
      errCode: "",
    };
  },
  watch: {
    login: function () {
      if (this.errLogin != "") {
        if (this.login != this.errLoginHist) {
          this.loginClass = false;
          this.errLogin = "";
        }
      }
      let testLogin = /\W/g;
      if (testLogin.test(this.login)) {
        this.loginClass = true;
        this.errLogin = this.messages.testLogin[this.store.langSelect.value];
        this.errLoginHist = this.login;
      }
    },
  },
  methods: {
    Registration() {
      const self = this;
      if (self.viewCode && self.code.length != 6) {
        this.codeClass = true;
        return;
      }
      this.codeClass = false;
      console.log(this.login + this.login.length);
      if (this.login.length < 3) {
        this.loginClass = true;
      } else {
        this.loginClass = false;
      }
      if (this.email.length < 3) {
        this.emailClass = true;
      } else if (
        this.email.indexOf("@") == -1 ||
        this.email.indexOf("+") !== -1
      ) {
        this.emailClass = true;
      } else {
        this.emailClass = false;
      }
      if (this.pass.length < 6) {
        this.passClass = true;
      } else {
        this.passClass = false;
      }
      if (this.pass != this.passConfirm) {
        this.passConfirmClass = true;
      } else {
        this.passConfirmClass = false;
      }
      if (
        !this.loginClass &&
        !this.emailClass &&
        !this.passClass &&
        !this.passConfirmClass
      ) {
        if (this.checkingEmail == this.email) {
          this.sendRegistration();
        } else {
          this.sendCheckEmail();
        }
      }
    },
    sendCheckEmail() {
      const self = this;
      self.viewCode = true;
      axios
        .get(self.store.ServerUrl + "/users/sendcode/" + this.email)
        .then(function (response) {
          if (response.data.code === 0) {
            self.checkingEmail = self.email;
            //self.viewCode = true;
          }
        });
    },
    sendRegistration() {
      const self = this;
      const salt = "$1$ae_salt";
      const data = {
        login: this.login,
        pass: md5(this.pass + salt),
        lang: this.store.langTextes[this.store.langSelect.value],
        email: this.email,
        useAuthCode: false,
        passCert: this.programPassword,
        code: this.code,
      };
      if (
        this.$route.params.referral != undefined &&
        this.$route.params.referral != ""
      ) {
        data.refOID = this.$route.params.referral;
      }
      axios
        .post(self.store.ServerUrl + "/users/createUser", data)
        .then(function (response) {
          if (response.data.code === 0) {
            self.$router.push("/lk");
            //self.autoLink("/lk");
          } else {
            if (response.data.code === 111) {
              self.codeClass = true;
              self.errCode = response.data.msg;
            } else {
              self.viewCode = false;
              self.errLoginHist = self.login;
              self.loginClass = true;
              self.errLogin = response.data.msg;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    autoLink(url) {
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
<style lang="scss">
body {
  color: #333;
  background-color: #e9e9e9;
  width: 100%;
  height: 100%;
}
@media (max-height: 520px) {
  #register_full_form {
    top: 0 !important;
    transform: translate(-50%, 0) !important;
  }
}
@media (min-width: 750px) {
  #register_full_form {
    width: 749px;
    height: 722px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    #register_header {
      width: 749px;
      height: 141px;
    }
    #register_content {
      width: 749px;
      height: 581px;
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.06);
      display: flex;
      #register_form {
        width: 331px;
        height: 461px;
        background-color: white;
        padding: 60px;
        .register_form_input_error {
          border: 1px solid #c4c4c4;
          padding: 12px 20px;
          height: 20px;
          width: 291px;
          margin-bottom: 20px;
          background-image: none;
          /* border: none;
   Пароль */
          font-family: Roboto Regular;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 20px;
          /* identical to box height */

          /* color: #a5a5a5;*/
          border: 1px solid #e82862;
          background-image: none;
          outline: none;
        }
        .register_form_input {
          border: 1px solid #c4c4c4;
          padding: 12px 20px;
          height: 20px;
          width: 291px;
          margin-bottom: 20px;
          background-image: none;
          /* border: none;
   Пароль */
          font-family: Roboto Regular;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 20px;
          /* identical to box height */

          /* color: #a5a5a5;*/
        }
      }
      #register_img {
        position: relative;
        width: 298px;
        height: 581px;
        /*background-size: 47px 31px;*/
      }
    }
  }
}
@media (max-width: 750px) {
  #register_full_form {
    width: 100%;
    height: 722px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    #register_header {
      width: 100%;
      height: 141px;
    }
    #register_content {
      width: 100%;
      height: 581px;
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.06);
      display: flex;
      border-radius: 0 0 40px;
      #register_form {
        width: 100%;
        height: 461px;
        background-color: white;
        padding: 10px;
        .register_form_input_error {
          border: 1px solid #c4c4c4;
          padding: 12px 20px;
          height: 20px;
          width: calc(100% - 40px);
          margin-bottom: 20px;
          background-image: none;
          /* border: none;
   Пароль */
          font-family: Roboto Regular;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 20px;
          /* identical to box height */

          /* color: #a5a5a5;*/
          border: 1px solid #e82862;
          background-image: none;
          outline: none;
        }
        .register_form_input {
          border: 1px solid #c4c4c4;
          padding: 12px 20px;
          height: 20px;
          width: calc(100% - 40px);
          margin-bottom: 20px;
          background-image: none;
          /* border: none;
   Пароль */
          font-family: Roboto Regular;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 20px;
          /* identical to box height */

          /* color: #a5a5a5;*/
        }
      }
      #register_img {
        display: none;
      }
    }
  }
}

#register_title {
  margin-bottom: 15px;
  font-family: Proxima Nova Condensed;
  font-style: normal;
  /* font-weight: 600;*/
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  color: #222222;
}

.register_form_input:focus {
  border: 1px solid #222;
  background-image: none;
  outline: none;
}

#register_form a {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
  text-underline-position: under;
}
#register_form a:hover {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #e82862;
  text-underline-position: under;
}
#register_login {
  margin-top: 30px;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
}
#register_text {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #777;
  margin-bottom: 25px;
}
#errCode,
#errLogin {
  color: #e82862;
}
</style>
